import { mergeAttributes, Node } from "@tiptap/core"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { BLOCK_RENDER_AS, linkAttributes, type Link } from "./link-attrs"
import { LinkComponent } from "./link-component"

/**
 * The block form of the unified Link (docs/unified-links.md §4): identical attrs to
 * linkInline — same component, same menu, same dialog — differing only in group and
 * its allowed renderAs subset ("block" | "preview").
 */
export const ExtensionLinkBlock = Node.create({
  name: "linkBlock",
  group: "block widget", // "widget" per the editor's widget conventions (see CLAUDE.md)
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes: () => linkAttributes(BLOCK_RENDER_AS),

  renderHTML({ node, HTMLAttributes }) {
    // Render as a normal link for the clipboard, tagged so it round-trips (§4).
    const attrs = node.attrs as Link
    return [
      "a",
      mergeAttributes(HTMLAttributes, { "data-content-type": "linkBlock", href: attrs.url }),
      attrs.title ?? attrs.url,
    ]
  },

  parseHTML() {
    return [{ tag: 'a[data-content-type="linkBlock"]', priority: 60 }]
  },

  addNodeView() {
    return ReactNodeViewRenderer(LinkComponent)
  },
})
